<template>
  <div>
    <v-dialog v-model="viewMemberQRDialog" persistent width="350px">
      <v-toolbar dense class="elevation-0 gradient-bg white--text">
        <v-toolbar-title
          >QR for
          {{
            locationObjectMain.location_name != undefined
              ? locationObjectMain.location_name
              : locationObjectMain.location_name
          }}</v-toolbar-title
        >
        <v-spacer />
        <v-icon @click="close_dialog()" class="white--text mr-n3"
          >mdi-close</v-icon
        >
      </v-toolbar>
      <v-card class="overflow--hidden">
        <v-card-text align="center" justify="center">
          <v-img contain width="140px" v-if="url" :src="url" height="90px">
          </v-img>
          <v-img
            v-else
            src="@/assets/prezsqu.png"
            class=""
            height="145"
            width="145"
          >
          </v-img>
        </v-card-text>
        <div v-if="viewSourceItems != undefined && viewSourceItems != ''">
          <v-card-text class="mt-n5" align="center" justify="center">
            <VueQRCodeComponent
              :text="member_qr"
              error-level="H"
              :size="150"
            ></VueQRCodeComponent>
          </v-card-text>
          <v-card-text align="center" justify="center">
            <!-- <v-img src="@/assets/prezwww.png" class="mt-n3" max-width="180">
                    </v-img
                  > -->
            <span class="black--text subtitle-2">
              {{ $store.getters.get_org_details[0].organisation_name }}<br />
              {{ locationObjectMain.location_name }} </span
            ><br />
            <span class="primary--text subtitle-2">www.prznce.com/App</span>
          </v-card-text>

          <v-card-text align="center" justify="center">
            <v-btn
              class="gradient-bg white--text mt-n5 ml-3"
              @click="generateReport()"
              ><v-icon medium class="mr-2">mdi-qrcode-scan</v-icon>Print
              QR</v-btn
            >
          </v-card-text>
        </div>
        <div v-else>
          <v-card-text
            class="mt-n5"
            align="center"
            justify="center"
            v-if="loadvalue == true"
          >
            Please regenerate the QR code, it was not generated properly.

            <v-card-text align="center" justify="center">
              <v-btn
                class="gradient-bg white--text mt-5"
                @click="list_sources_locations()"
              >
                Regenerate</v-btn
              >
            </v-card-text>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <div v-if="viewMemberQRDialog == true">
      <v-card>
        <v-card-text align="center" justify="center" style="margin-left: -10px">
          <vue-html2pdf
            :float-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :filename="
              locationObjectMain.location_name != undefined
                ? locationObjectMain.location_name
                : locationObjectMain.location_name + ' - QR'
            "
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a6"
            pdf-orientation="portrait"
            :paginate-elements-by-height="800"
            pdf-content-width="420px"
            ref="html2Pdf"
          >
            <section slot="pdf-content" class="qr-pdf-page">
              <div class="qr-pdf-card">
                <div class="qr-pdf-logo-wrap">
                  <img v-if="url" :src="url" class="qr-pdf-logo" />
                  <img v-else src="@/assets/prezsqu.png" class="qr-pdf-logo" />
                </div>

                <div class="qr-pdf-title">Location QR Code</div>

                <div class="qr-pdf-qr-row mt-4">
                  <VueQRCodeComponent
                    :text="member_qr"
                    error-level="H"
                    :size="150"
                  ></VueQRCodeComponent>
                </div>

                <div class="qr-pdf-info mt-4">
                  <div class="qr-pdf-org">
                    {{ $store.getters.get_org_details[0].organisation_name }}
                  </div>
                  <div class="qr-pdf-location">
                    {{ locationObjectMain.location_name }}
                  </div>
                </div>

                <div class="qr-pdf-footer">www.prznce.com/App</div>
              </div>
            </section>
          </vue-html2pdf>
        </v-card-text>
      </v-card>
    </div>
    <Overlay :overlay="overlay" />
  </div>
</template>

<script>
import Overlay from "@/components/Overlay.vue";
import VueQRCodeComponent from "vue-qr-generator";
import { API, graphqlOperation } from "aws-amplify";
import { GetSourcesTaggedToLocations } from "@/graphql/queries.js";
import VueHtml2pdf from "vue-html2pdf";
export default {
  props: {
    viewMemberQRDialog: Boolean,
    locationObjectMain: Object,
  },
  components: { VueQRCodeComponent, VueHtml2pdf, Overlay },
  data: () => ({
    member_qr: "",
    url: "",
    viewSourceItems: "",
    loadvalue: false,
    overlay: false,
    debugQrDomLogged: false,
  }),
  created() {
    this.url = this.$store.getters.get_org_details[0].organisation_logo;
  },
  // watch: {
  //   viewMemberQRDialog: {
  //     handler() {
  //       {
  //         this.list_sources_locations();
  //         setTimeout(() => {
  //           if (this.viewMemberQRDialog == true) {
  //             // setTimeout(() => {

  //             setTimeout(() => {
  //               this.member_qr = `https://www.prznce.com/Apps/myprezence?qr_id=${this.viewSourceItems}`;
  //             }, 300);
  //             // console.log("asd", this.viewSourceItems);
  //             // this.member_qr =
  //             //   this.locationObjectMain.user_id != undefined
  //             //     ? `https://www.prezence.app/Apps/myprezence?qr_id=PROXY#${this.locationObjectMain.user_id}`
  //             //     : `https://www.prezence.app/Apps/myprezence?qr_id=${this.viewSourceItems}`;
  //             // console.log(this.viewSourceItems, "member_qr");
  //             // }, 100);
  //           }
  //         }, 300);
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  watch: {
    viewMemberQRDialog: {
      async handler() {
        if (this.viewMemberQRDialog == true) {
          this.overlay = true;
          await this.list_sources_locations();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // #region agent log
    debugLog(hypothesisId, message, data = {}) {
      fetch(
        "http://127.0.0.1:7805/ingest/ae004996-34b8-4ffe-b50d-f5d31e31ce30",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Debug-Session-Id": "7c4c2a",
          },
          body: JSON.stringify({
            sessionId: "7c4c2a",
            runId: "initial",
            hypothesisId,
            location: "src/components/Dialogs/ViewLocationQR.vue",
            message,
            data,
            timestamp: Date.now(),
          }),
        },
      ).catch(() => {});
    },
    inspectPdfQrDom() {
      const pdfRoot = this.$el && this.$el.querySelector(".qr-pdf-page");
      const pdfCard = this.$el && this.$el.querySelector(".qr-pdf-card");
      const qrEl =
        this.$el &&
        (this.$el.querySelector(".qr-pdf-qr-row") ||
          this.$el.querySelector(".qr-pdf-code"));
      const canvas =
        qrEl && (qrEl.matches("canvas") ? qrEl : qrEl.querySelector("canvas"));
      const svg =
        qrEl && (qrEl.matches("svg") ? qrEl : qrEl.querySelector("svg"));
      const img =
        qrEl && (qrEl.matches("img") ? qrEl : qrEl.querySelector("img"));
      const pageStyle = pdfRoot ? window.getComputedStyle(pdfRoot) : null;
      const cardStyle = pdfCard ? window.getComputedStyle(pdfCard) : null;
      const style = qrEl ? window.getComputedStyle(qrEl) : null;
      const pdfRootRect = pdfRoot ? pdfRoot.getBoundingClientRect() : null;
      const pdfCardRect = pdfCard ? pdfCard.getBoundingClientRect() : null;
      const rect = qrEl ? qrEl.getBoundingClientRect() : null;
      const canvasRect = canvas ? canvas.getBoundingClientRect() : null;

      return {
        pdfRootExists: Boolean(pdfRoot),
        pdfRootHeight: pdfRootRect ? pdfRootRect.height : null,
        pdfRootBackground: pageStyle ? pageStyle.backgroundColor : null,
        pdfCardExists: Boolean(pdfCard),
        pdfCardHeight: pdfCardRect ? pdfCardRect.height : null,
        pdfCardDisplay: cardStyle ? cardStyle.display : null,
        pdfCardPaddingLeft: cardStyle ? cardStyle.paddingLeft : null,
        pdfCardPaddingRight: cardStyle ? cardStyle.paddingRight : null,
        pdfCardGap: cardStyle ? cardStyle.gap : null,
        pdfCardAlignItems: cardStyle ? cardStyle.alignItems : null,
        pdfCardJustifyContent: cardStyle ? cardStyle.justifyContent : null,
        qrClassElementExists: Boolean(qrEl),
        qrClassTag: qrEl ? qrEl.tagName : null,
        hasCanvas: Boolean(canvas),
        hasSvg: Boolean(svg),
        hasImg: Boolean(img),
        qrElementWidth: rect ? rect.width : null,
        qrElementHeight: rect ? rect.height : null,
        canvasWidth: canvas ? canvas.width : null,
        canvasHeight: canvas ? canvas.height : null,
        canvasRenderedWidth: canvasRect ? canvasRect.width : null,
        canvasRenderedHeight: canvasRect ? canvasRect.height : null,
        display: style ? style.display : null,
        visibility: style ? style.visibility : null,
        opacity: style ? style.opacity : null,
        padding: style ? style.padding : null,
        border: style ? style.border : null,
      };
    },
    // #endregion
    generateReport() {
      // #region agent log
      this.debugLog("H2,H3,H4,H5,H6,H7,H8", "generateReport before generatePdf", {
        memberQrReady: Boolean(this.member_qr),
        memberQrLength: this.member_qr ? this.member_qr.length : 0,
        viewSourceItemsReady: Boolean(this.viewSourceItems),
        html2PdfRefReady: Boolean(this.$refs.html2Pdf),
        dom: this.inspectPdfQrDom(),
      });
      // #endregion
      this.$refs.html2Pdf.generatePdf();
    },
    close_dialog() {
      this.$emit("close_view_qr_dialog");
    },
    async list_sources_locations() {
      this.overlay = true;
      this.isLoading = true;
      try {
        await API.graphql(
          graphqlOperation(GetSourcesTaggedToLocations, {
            input: {
              location_id: this.locationObjectMain.location_id,
            },
          }),
        ).then((res) => {
          // console.log(
          //   res.data.GetSourcesTaggedToLocations.data[0],
          //   "simplified"
          // );
          // console.log(res.data.GetSourcesTaggedToLocations, "example");
          this.loadvalue = true;
          this.viewSourceItems =
            res.data.GetSourcesTaggedToLocations.data[0].qr_id;
          this.member_qr = `https://www.prznce.com/Apps/myprezence?qr_id=${this.viewSourceItems}`;
          // #region agent log
          this.debugLog("H2", "QR source loaded from API", {
            responseHasData: Boolean(
              res.data &&
                res.data.GetSourcesTaggedToLocations &&
                res.data.GetSourcesTaggedToLocations.data &&
                res.data.GetSourcesTaggedToLocations.data.length,
            ),
            qrIdReady: Boolean(this.viewSourceItems),
            memberQrReady: Boolean(this.member_qr),
            memberQrLength: this.member_qr ? this.member_qr.length : 0,
          });
          this.$nextTick(() => {
            if (this.debugQrDomLogged) return;
            this.debugQrDomLogged = true;
            this.debugLog("H1,H3,H4,H5,H6,H7,H8", "PDF QR DOM after QR data render", {
              dom: this.inspectPdfQrDom(),
            });
          });
          // #endregion
          // res.data.GetSourcesTaggedToLocations.data[0] != 0
          //   ? res.data.GetSourcesTaggedToLocations.data
          //   : [];
          // console.log(this.viewSourceItems, "id");
          this.overlay = false;
          this.isLoading = false;
          if (this.viewSourceItems == undefined || this.viewSourceItems == "") {
            this.overlay = false;
            this.$store.commit("snackbar/showMessage", {
              content: "Faild to Regenerate",
              color: "red",
            });
          }
        });
      } catch (err) {
        console.log("errrrr", err);
        this.$store.commit("snackbar/showMessage", {
          content: err.errors[0].message,
          color: "red",
        });
        this.overlay = false;
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.qr-pdf-page {
  width: 420px;
  height: 520px;
  padding: 0;
  background: #ffffff;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-pdf-card {
  width: 100%;
  height: 100%;
  padding: 28px 40px 28px 8px;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  text-align: center;
}

.qr-pdf-logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.qr-pdf-logo {
  max-width: 170px;
  max-height: 70px;
  object-fit: contain;
}

.qr-pdf-title {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

.qr-pdf-qr-row {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.qr-pdf-info {
  color: #111827;
}

.qr-pdf-org {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.qr-pdf-location {
  margin-top: 8px;
  color: #374151;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
}

.qr-pdf-footer {
  margin: 0;
  color: #1976d2;
  font-size: 14px;
  font-weight: 700;
}
</style>
